import * as React from 'react';
import { FIELD_TYPE } from 'app/infrastructure/simple-form';
import { FilterCommonProps } from '../types';
import { RadioSymbol } from 'ui';
import { OptionTypes, FilterOption } from 'app/components/filters/types';
import { FilterOptionType } from 'app/area/filters/types';
import { customFilterFieldPostfix } from 'app/components/filters/filters-panel/constants';

export interface FilterNumberProps extends FilterCommonProps {
  onFilterOptionType: (filterOption: FilterOption, filterOptionType: FilterOptionType) => void;
}

export class FilterNumber extends React.Component<FilterNumberProps> {
  private handleOptionChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
    const selectedOption = Number(e.currentTarget.value);

    this.props.onFilterOptionType({
      id: this.props.filterDomain.id,
      type: selectedOption
    }, FilterOptionType.OPTION_TYPE);
  };

  private renderSpecificNumbersOrRanges = () => {
    const { simpleFormComponent: SimpleForm, initialValue, filterDomain: { id: name, optionType }, translation } = this.props;
    const selected = optionType !== OptionTypes.NotSpecified;

    return <div className="form-check">
      <input
        id={`${this.props.filterDomain.id}-specific-numbers-or-ranges`}
        type="radio"
        className="form-check-input visuallyhidden"
        value={OptionTypes.SpecificNumbersOrRanges}
        checked={selected}
        onChange={this.handleOptionChange} />
      <label
        htmlFor={`${this.props.filterDomain.id}-specific-numbers-or-ranges`}
        className="form-check-label">
        <RadioSymbol />
        <div>
          <b>{translation.filters_specific_numbers_ranges_title}</b>
          <p>{translation.filters_specific_numbers_ranges_subtitle}</p>
        </div>
      </label>

      {selected && <SimpleForm
        name={name + customFilterFieldPostfix.number}
        type={FIELD_TYPE.TEXTAREA}
        initialValue={initialValue && initialValue.length > 0 ? initialValue[0].value : ''}
      />}
    </div>;
  };

  private renderNotSpecified = () => {
    const { simpleFormComponent, translation, filterDomain: { id: name, optionType } } = this.props;
    const SimpleForm = simpleFormComponent;
    const selected = optionType === OptionTypes.NotSpecified;

    return <div className="form-check">
      <input
        id={`${this.props.filterDomain.id}-not-specified`}
        type="radio"
        className="form-check-input visuallyhidden"
        value={OptionTypes.NotSpecified}
        checked={selected}
        onChange={this.handleOptionChange} />
      <label
        htmlFor={`${this.props.filterDomain.id}-not-specified`}
        className="form-check-label">
        <RadioSymbol />
        <div>
          <b>{translation.filters_not_specified_title}</b>
          <p>{translation.filters_not_specified_subtitle}</p>
        </div>
        {selected && <div className="d-none">
            <SimpleForm
              name={name + customFilterFieldPostfix.notSpecified}
              type={FIELD_TYPE.TEXTAREA}
              initialValue={translation.filters_not_specified_title}
            />
          </div>}
      </label>
    </div>;
  };

  public render() {
    return <>
      {this.renderSpecificNumbersOrRanges()}
      {this.renderNotSpecified()}
    </>;
  }
}
